import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StaticModule } from './static/static.module';
import { CoreModule } from './core/core.module';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeDe, 'de');
import { environment } from '../environments/environment';
import localeDe from '@angular/common/locales/de';
import { QuillModule } from 'ngx-quill';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        CoreModule,
        StaticModule,
        QuillModule.forRoot(),
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'de' },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
        provideFirebaseApp(() => initializeApp(environment.firebasecfg)),
        provideFirestore(() => getFirestore()),
        provideFunctions(() => getFunctions(getApp(), 'europe-west3')),
        provideFirebaseApp(() => initializeApp(environment.logsConfig, 'pdrcloudlogs')),
        provideFirestore(() => getFirestore(getApp('pdrcloudlogs'))),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
